export default __webpack_public_path__ + "static/avatar-0ae3c94a7cc3e737bf86c35aeb9e5c52.webp";